import util from "./util";
import Cookies from "js-cookie";
import axios from 'axios';
import store from "@/store";

let CancelToken = axios.CancelToken;
let api = {};
import dayjs from 'dayjs'

//注册
api.signUp = params => {
  return util.ajax({
    url: "/api/user/registry",
    method: "put",
    headers: { "Content-Type": "application/json" },
    data: params
  });
};
//登录
api.signIn = params => {
  return util.ajax({
    url: "/api/user/session",
    method: "put",
    headers: { "Content-Type": "application/json" },
    data: params
  });
};
//登录   官网
api.getSessionData = () => {
  return util.ajax({
    url: "/api/user/session",
    method: "get",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },

  });
};
// 查询用户拥有权限的项目和所在项目的组
api.getSelfGroups = () => {
  return util.ajax({
    url: "/api/user/projects/group",
    method: "get",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//注销登录
api.logout = () => {
  return util.ajax({
    url: "/api/user/session",
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//添加新用户
api.addUser = params => {
  return util.ajax({
    url: "/api/user",
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params
  });
};
//注销用户,删除之后调用 todo:删除用户后注销该用户
api.deleteUser = userId => {
  return util.ajax({
    url: `/api/user/${userId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//管理员重置密码
api.resetPassWordAdmin = params => {
  return util.ajax({
    url: "/api/user/password/admin",
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params
  });
};
//修改密码
api.chgPassword = params => {
  return util.ajax({
    url: "/api/user/password",
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params
  });
};
//查询全部用户
api.getAllUser = () => {
  return util.ajax({
    url: `/api/project/users`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//查询指定项目用户
api.getProjectMember = projectId => {
  return util.ajax({
    url: `/api/project/users/${projectId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//查询用户组
api.getUserGroups = () => {
  return util.ajax({
    url: "/api/user/group",
    method: "get",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//为用户指定组
api.setUserGroup = (groupId, projectId, userIds) => {
  return util.ajax({
    url: `/api/user/group/${groupId}/${projectId}/${userIds}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//项目管理员移除成员
api.removeProjectMember = (projectId, derivedUserIds) => {
  return util.ajax({
    url: `/api/user/project/${projectId}/${derivedUserIds}`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//查询资源,菜单列表
api.getResource = () => {
  return util.ajax({
    url: "/api/user/privilege/resources/tree",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
//查询项目
api.getProjectList = organizationId => {
  return new Promise(resolve => {
    util.ajax({
      url: `/api/project/${Cookies.get('organizationId')}`,
      headers: {
        "Content-Type": "application/json",
        userId: Cookies.get("userId"),
        token: Cookies.get("token")
      },
      method: "get"
    }).then(res => {
      res.data.fields.list.forEach(item => {
        const obj = item.props.find(item => item.ename === 'dataURL')
        if (obj) {
          const obj2 = item.props.find(item => item.ename === 'sslCert' && item.val)

          if (obj2) {
            obj.httpVal = 'https://' + obj.val
          } else {
            obj.httpVal = 'http://' + obj.val
          }
        }
      })
      resolve(res)
    })
  })
};
//添加项目
api.addProject = (organizationId, params) => {
  return util.ajax({
    url: `/api/project/${Cookies.get('organizationId')}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params
  });
};
//修改项目
api.updataProject = (projectId, params) => {
  return util.ajax({
    url: `/api/project/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put", data: params
  });
};
//删除项目
api.deleteProject = projectId => {
  return util.ajax({
    url: `/api/project/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

/*----------------------------------------------------------------api---------------------------------------------------------------*/

// 1.1    事件分析项目元数据
api.getMetadata = projectId => {
  const p1 = new Promise((resolve, reject) => {
    util
      .ajax({
        url: `/api/project/metadata/${projectId}/event/1`,
        headers: {
          "Content-Type": "application/json",
          userId: Cookies.get("userId"),
          token: Cookies.get("token")
        },
        method: "get"
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
  const p2 = new Promise((resolve, reject) => {
    util
      .ajax({
        url: `/api/project/metadata/${projectId}/user/1`,
        headers: {
          "Content-Type": "application/json",
          userId: Cookies.get("userId"),
          token: Cookies.get("token")
        },
        method: "get"
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
  const p3 = new Promise((resolve, reject) => {
    util
      .ajax({
        url: `/api/project/metadata/${projectId}/segm/1`,
        headers: {
          "Content-Type": "application/json",
          userId: Cookies.get("userId"),
          token: Cookies.get("token")
        },
        method: "get"
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

  return new Promise((resolve, reject) => {
    Promise.all([p1, p2, p3])
      .then(res => {
        if (res.every(item => item.data.status === 1)) {
          const result = Object.assign({}, res[0], {
            data: Object.assign({}, res[0].data, {
              fields: {
                event: res[0].data.fields.event,
                user: res[1].data.fields.user,
                segm: res[2].data.fields.segm
              }
            })
          });
          resolve(result);
        }
        // else {
        //   reject("元数据获取失败");
        // }
      })
      .catch(err => {
        reject(err);
      });
  });
};

// 获取分群
api.getMetaSeg = projectId => {
  return util.ajax({
    url: `/api/project/metadata/${projectId}/segm/1`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
// 1.1    事件分析项目元数据（管理员）
api.getMetadataAdmin = projectId => {
  return util.ajax({
    url: `/api/project/metadata/${projectId}/event,user/1,0`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};

//1.2.1   增加tag
api.addTag = (projectId, param) => {
  return util.ajax({
    url: `/api/event/tag/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: param
  });
};

//      修改tag
api.editTag = (projectId, tagId, params) => {
  return util.ajax({
    url: `/api/event/tag/${projectId}/${tagId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: params
  });
};

//1.2.2   删除tag
api.deleteTag = (projectId, tagId) => {
  return util.ajax({
    url: `/api/event/tag/${projectId}/${tagId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

//1.2.3   查询tag
api.getTags = projectId => {
  return util.ajax({
    url: `/api/event/tag/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};

//1.3.1   添加事件与tag的关系
api.addTagRelation = (projectId, eventId, tagId) => {
  return util.ajax({
    url: `/api/event/tag/relation/${projectId}/${eventId}/${tagId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put"
  });
};

//1.3.2   删除事件和tag的关系
api.deleteTagRelation = (projectId, eventId, tagId) => {
  return util.ajax({
    url: `/api/event/tag/relation/${projectId}/${eventId}/${tagId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

//1.4   字典
api.getDict = (projectId, propertyId) => {
  return util.ajax({
    url: `/api/dic/${projectId}/${propertyId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
api.getDictValue = (projectId, propertyId) => {
  return util.ajax({
    url: `/api/dic/value/${ projectId }/${ propertyId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  })
}
api.addDict = param => {
  let { projectId, propertyId, editType, formData } = param;
  return util.ajax({
    url: `/api/dic/${projectId}/${propertyId}?edit=${editType}`,
    headers: {
      "Content-Type": "multipart/form-data",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: formData
  });
};
api.deleteDict = param => {
  let { projectId, propertyId } = param;
  return util.ajax({
    url: `/api/dic/${projectId}/${propertyId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};
api.exportDict = param => {
  let { projectId, propertyId } = param;
  return util.ajax({
    url: `/api/dic/export/${projectId}/${propertyId}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  });
};

//1.5.1   添加/修改虚拟事件
api.addMetaEvent = (projectId, param) => {
  return util.ajax({
    url: `/api/event/virtual/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: param
  });
};

//1.5.2   修改事件
api.editEvent = (projectId, param) => {
  return util.ajax({
    url: `/api/event/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: param
  });
};

//      修改分组
api.editProperties = (projectId, param) => {
  return util.ajax({
    url: `/api/project/metadata/props/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: param
  });
};

//1.6.1   添加/修改分组
api.addGroup = (projectId, panelId, param) => {
  return util.ajax({
    url: `/api/event/eventgroup/${projectId}/${panelId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: param
  });
};

//1.6.2   删除分组
api.deleteGroup = (projectId, panelId, id) => {
  return util.ajax({
    url: `/api/event/eventgroup/${projectId}/${panelId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};
// 事件分析下载数据
api.download = (projectId, params) => {
  let { measures, filter, groupBy, timeRange, timeUnit, cache, requestId, sampling } =
    JSON.parse(JSON.stringify(params));
  return util.ajax({
    url: `/api/events/export/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: {
      sampling,
      measures,
      filter,
      groupBy,
      timeRange,
      timeUnit,
      cache,
      requestId,
    },
  });
}
api.putEventgroupSort = (projectId, panelId, ids) => {
  return util.ajax({
    url: `/api/event/eventgroup/sort/${projectId}/${ids}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "PUT"
  })
}
api.putEventgroupPanelDefault = (projectId, panelId) => {
  return util.ajax({
    url: `/api/eventgroup/panel/default/${ projectId }/${ panelId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "PUT"
  })
};
// 1.6.3    当前画板所有的分组信息
api.getEventGroups = (projectId, panelId) => {
  return util.ajax({
    url: `/api/event/eventgroup/${projectId}/${panelId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};

//1.7.1   添加事件与分组的关系
api.addGroupRelation = (projectId, eventId, groupId) => {
  const eventIds = eventId.split(",");
  const ids = [...new Set(eventIds)].join(",");
  return util.ajax({
    url: `/api/eventgroup/relation/${projectId}/${ids}/${groupId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put"
  });
};

//1.7.2   删除事件与分组的关系
api.deleteGroupRelation = (projectId, eventId, groupId) => {
  return util.ajax({
    url: `/api/eventgroup/relation/${projectId}/${eventId}/${groupId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

//1.10.2修改事件与分组的关系
api.editGroupRelation = (projectId, params) => {
  return util.ajax({
    url: `/api/eventgroup/relation/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: params
  });
};

//1.8.1   添加/修改画板
api.addPanel = (projectId, param) => {
  return util.ajax({
    url: `/api/eventgroup/panel/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: param
  });
};

//1.8.2   删除画板
api.deletePanel = (projectId, panelId) => {
  return util.ajax({
    url: `/api/eventgroup/panel/${projectId}/${panelId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

//1.8.3   查询画板
api.getPanels = projectId => {
  return util.ajax({
    url: `/api/eventgroup/panel/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//查询事件与用户的关系
api.getAnalystsEventsRelations = projectId => {
  return util.ajax({
    url: `/api/event/user/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
//创建事件与用户关系
api.setAnalystsEventsRelations = (projectId, userId, eventId) => {
  return util.ajax({
    url: eventId ? `/api/event/user/${projectId}/${userId}/${eventId}` : `/api/event/user/${projectId}/${userId}/`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put"
  });
};

//获取虚拟事件
api.getVirtualEvents = projectId => {
  return util.ajax({
    url: `/api/event/virtual/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
//增加虚拟事件
api.addVirtualEvents = (projectId, params) => {
  return util.ajax({
    url: `/api/event/virtual/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: params
  });
};
//删除虚拟事件
api.deleteVirtualEvents = (projectId, eventId) => {
  return util.ajax({
    url: `/api/event/virtual/${projectId}/${eventId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};
// 虚拟属性
//获取虚拟属性
api.getAttribute = projectId => {
  return util.ajax({
    url: `/api/virtualProperty/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
api.getAttributeEvents = (projectId, propertyId) => {
  return util.ajax({
    url: `/api/virtualProperty/events/${projectId}/${propertyId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
//创建虚拟属性
api.addAttribute = (projectId, params) => {
  return util.ajax({
    url: `/api/virtualProperty/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params
  });
};
//修改虚拟属性
api.updataAttribute = (projectId, id, params) => {
  return util.ajax({
    url: `/api/virtualProperty/${projectId}/${id} `,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: params
  });
};
//启停虚拟属性
api.userAttribute = (projectId, id, use) => {
  return util.ajax({
    url: `/api/virtualProperty/status/${projectId}/${id}?use=${use}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
  });
};
//删除虚拟属性
api.deleteAttribute = (projectId, id) => {
  return util.ajax({
    url: `/api/virtualProperty/${projectId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};
// ----------------------------------------------
//2.1   获取事件
api.getReports = (projectId, param) => {
  return util.ajax({
    url: `/api/events/report/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: {
      ...param,
      requestId: `${ new Date().getTime().toString() }:${ Cookies.get("userId") }:${ Math.floor(Math.random() * 900) + 100
        }`,
    }
  }).then(res => {
    res.data.fields.series.splice(5000, res.data.fields.series.length - 1000)
    res.data.fields.series.forEach(item => {
      item.y.splice(5000)
    })
    return res
  })
};
//2.2获取用户明细列表
api.getUserDetails = (projectId, param) => {
  return util.ajax({
    url: `/api/events/user/report/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: param
  });
};

//3.1   添加/更新书签
api.addBookmark = (projectId, param) => {
  if (param.type === 'event') {
    const params = JSON.parse(JSON.stringify(param))
    params.data.measures.forEach(item => {
      if (item.expression) {
        item.expression.forEach(item2 => {
          delete item2.eventProps
        })
      }
    })
    param = params
  }
  return util.ajax({
    url: `/api/bookmark/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: param
  });
};

//3.2   获取书签
api.getBookmarks = projectId => {
    return util.ajax({
      url: `/api/bookmark/${projectId}`,
      headers: {
        "Content-Type": "application/json",
        userId: Cookies.get("userId"),
        token: Cookies.get("token")
      },
      method: "get",
      transformResponse (data) {
        const res = data.replace(/("(conditions|filters|relate|groupBy)":)null/g, (_, key) => `${key}[]`)
        return JSON.parse(res)
      }
  })
};

//3.3   删除书签
api.deleteBookmark = (projectId, bookmarkId) => {
  return util.ajax({
    url: `/api/bookmark/${projectId}/${bookmarkId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

//4.1   添加/修改数据概览
api.addDashboard = (projectId, param) => {
  return util.ajax({
    url: `/api/dashboard/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: param
  });
};

//4.2   删除数据概览
api.deleteDashboard = (projectId, dashboardId) => {
  return util.ajax({
    url: `/api/dashboard/${projectId}/${dashboardId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};
//
//4.3   获取数据概览
api.getDashboards = projectId => {
  return util.ajax({
    url: `/api/dashboard/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};

//4.4   增加/修改概览条目
api.addDashboardItem = (projectId, param) => {
  const parmas2 = JSON.parse(JSON.stringify(param))
  if ((/(retention|ltv|attribution|distribution|behaviorPath|funnel|interval)/.test(parmas2.kind)) && parmas2.config.data && parmas2.config.data.timeRange) {
    if (!Array.isArray(parmas2.config.data.timeRange)) {
      parmas2.config.data.timeRange = [parmas2.config.data.timeRange]
    }
  }
  return util.ajax({
    url: `/api/dashboard/item/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: parmas2
  });
};

// 修改概鉴条目的顺序
api.changeDashboardItemIndex = (projectId, dashboardId, param) => {

  return util.ajax({
    url: `/api/dashboard/item/order/${projectId}/${dashboardId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: param
  });
};

//4.5   删除概览条目
api.deleteDashboardItem = (projectId, dashboardItemId) => {
  return util.ajax({
    url: `/api/dashboard/item/${projectId}/${dashboardItemId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

const eventKeys = {}
const itemData = {}
//4.6   获取概览条目
api.getDashboardItems = (projectId, dashboardId) => {
    return util.ajax({
      url: `/api/dashboard/items/${projectId}/${dashboardId}`,
      headers: {
        "Content-Type": "application/json",
        userId: Cookies.get("userId"),
        token: Cookies.get("token")
      },
      method: "get",
      transformResponse (data) {
        const res = data.replace(/("(conditions|filters|relate|groupBy)":)null/g, (_, key) => `${key}[]`)
        return JSON.parse(res)
      },
    }).then(res => {
      // store.state.user.userInfo.token
      // res.data.fields.items.splice(2)
      // res.data.fields.items = [res.data.fields.items[0], res.data.fields.items[1]]
      res.data.fields.items.forEach(item => {
        const val = item.bookmarkData
        const itemId =item.itemId
        itemData[itemId] = []

        switch (item.kind) {

          // 归因
          case 'attribution':
            val.groupBy && val.groupBy.forEach(item => {
              api.queryPropertyName(item)
            })
            break
          case 'retention':
            api.queryEventName(val.ending, itemId)
            api.queryEventName(val.begining, itemId)

            break
          case 'ltv':
            val.revenue && val.revenue.forEach(item => {
              api.queryEventName(item, itemId)
            })
            api.queryEventName(val.begining, itemId)


            break
          // 间隔
          case 'interval':
            api.queryEventName(val.ending, itemId)
            api.queryEventName(val.begining, itemId)

            break
            // 分布
          case 'distribution':


            api.queryEventName(val.measure, itemId)
            api.queryEventName(val.meanwhile, itemId)

            val.groupBy && api.queryPropertyName(val.groupBy.field)
            break
            case 'retention':
              api.queryEventName(val.begining, itemId)
              api.queryEventName(val.ending, itemId)
            break
            case 'event':
              console.log(JSON.parse(JSON.stringify(val)), 'vvvvvvvvv')
              val.measures && val.measures.forEach(item => {
                api.queryEventName(item, itemId)
              })
              val.groupBy && val.groupBy.forEach(item => {
                api.queryPropertyName(item)
              })
            break
        }
      })

      res.data.fields.items.forEach(item => {
        item.eventData = itemData[item.itemId]
      })
      return res
    })
};


api.queryEventName = (obj, itemId) => {
  if (!obj) return

  let eventName = obj.eventName
  if (!eventName) return

  itemData[itemId].push(eventName)

  if (eventKeys[eventName]) return


  eventKeys[eventName] = true


  return util.ajax({
    url: `/api/project/metadata/event/cname/${store.state.app.projectId}/${obj.eventName}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  }).then(res => {
    if (res.status) {
      if (res.data.fields.cname) {
        console.log()
        store.commit("SET_NORMALEVENTS", [obj.eventName, res.data.fields.cname])
      }
    }
    return res
  })
};


api.queryPropertyName = (properties) => {
  if (!properties) return

  if (eventKeys[properties]) return

  eventKeys[properties] = true
  const [propType, propName] = properties.split(".")

  return util.ajax({
    url: `/api/project/metadata/prop/cname/${store.state.app.projectId}/${propType}/${propName}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  }).then(res => {
    if (res.status) {
      if (res.data.fields.cname) {
        console.log()
        store.commit("SET_NORMALEVENTS", [properties, res.data.fields.cname])
      }
    }
    return res
  })
};



//获取概览条目的数据
api.getDashboardItemDatas = (
  projectId,
  dashboardId,
  dashboardItemId,
  cacheStatus
) => {
  return util.ajax({
    url: `/api/dashboard/item/data/${projectId}/${dashboardId}/${dashboardItemId}${cacheStatus ||
      ""}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  })
};

//添加/修改定时任务
api.addSchedule = (projectId, params) => {
  return util.ajax({
    url: `/api/schedule/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: params
  });
};

//删除定时任务
api.deleteSchedule = (projectId, id) => {
  return util.ajax({
    url: `/api/schedule/${projectId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

//查询定时任务
api.getSchedules = (projectId, sourceKind, sourceId) => {
  return util.ajax({
    url: `/api/schedule/${projectId}/${sourceKind}/${sourceId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};

//4.7 概览分享查询（管理）
api.getDashShare = projectId => {
  return util.ajax({
    url: `/api/dashboard/share/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};

//4.8 修改概览分享（管理）
api.editDashShare = (projectId, dashboardId, users) => {
  return util.ajax({
    url: `/api/dashboard/share/${projectId}/${dashboardId}/${users}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put"
  });
};

//14事件预警
//14.1添加预警
api.addEarlyWarning = (projectId, params) => {
  return util.ajax({
    url: `/api/earlywarning/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params
  });
};
//14.1修改预警
api.updataEarlyWarning = (projectId, id, params) => {
  return util.ajax({
    url: `/api/earlywarning/${projectId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data: params
  });
};
//14.2查询预警
api.getEarlyWarning = projectId => {
  return util.ajax({
    url: `/api/earlywarning/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
//14.3删除指标预警
api.deleteEarlyWarning = (projectId, id) => {
  return util.ajax({
    url: `/api/earlywarning/${projectId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};
//14.4修改预警状态
api.chgWarningStatus = (projectId, id, status) => {
  return util.ajax({
    url: `/api/earlywarning/${projectId}/${id}/${status}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put"
  });
};

//15.1用户行为序列
api.getSequence = (params, data) => {
  let {
    projectId,
    userId,
  } = params;
  let appUserId = userId;

  return util.ajax({
    url: `/api/user/action/sequence/report/${projectId}/${appUserId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};

//15.2用户行为计数
api.getSequenceCount = (urlParams, data) => {
  let { projectId, userId } = urlParams;
  return util.ajax({
    url: `/api/user/actions/count/report/${projectId}/${userId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};
//15.3用户行为比例统计
api.getEventRatio = (urlParams, data) => {
  let { projectId, userId } = urlParams;
  return util.ajax({
    url: `/api/user/actions/ratio/report/${projectId}/${userId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};
//16.1用户属性分析
api.getUserPropsAnalysisData = (projectId, data) => {
  data.requestId = `${ new Date().getTime().toString() }:${ util.userId
  }:${ Math.floor(Math.random() * 900) + 100 }`
  return util.ajax({
    url: `/api/user/properties/report/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};
//获取用户明细列表-------用户属性分析
api.getUserDetailsByProps = (projectId, data) => {
  return util.ajax({
    url: `/api/user/list/report/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};

//  用户分群
//  查询用户分群
api.getUserSegmentation = projectId => {
  return util.ajax({
    url: `/api/profile/segmentation/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
//  查询分群历史数据(用户结果页)
api.getUserSegmentationHistory = params => {
  let { projectId, segmentationId, page, pageSize, from, to } = params;
  return util.ajax({
    url: `/api/profile/segmentation/${projectId}/${segmentationId}/${page}/${pageSize}${from ? "?from=" + from.replace(' ', '+') + "&to=" + to.replace(' ', '+') : ""
      }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
//  添加用户分群(上传创建)
// api.addUserSegmentation = (projectId, data) => {
//   return util.ajax({
//     url: `/api/profile/segmentation/${projectId}`,
//     // url: `/api/events/user/segmentation/${projectId}`,
//     headers: {
//       "Content-Type": "application/json",
//       userId: Cookies.get("userId"),
//       token: Cookies.get("token")
//     },
//     method: "post",
//     data: data
//   });
// };
//  添加用户分群(事件分析)
api.addUserSegmentations = (projectId, data) => {
  return util.ajax({
    // url: `/api/profile/segmentation/${projectId}`,
    url: `/api/events/user/segmentation/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};
//  添加用户分群(属性分析)
api.addUserS = (projectId, data) => {
  return util.ajax({
    url: `/api/user/segmentation/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};
// 添加/修改用户分群
api.addUserSegmentation = (projectId, data, method, execute, id) => {
  return util.ajax({
    url: execute ? `/api/profile/segmentation/${projectId}${id ? '/' + id : ''}?execute=${execute}` : `/api/profile/segmentation/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: method,  // post 添加    put  修改
    data: data
  });
};
//  查看分群用户列表
api.getUserSegmentationResult = (projectId, data) => {
  let { segmentationId, baseTime, version, page, pageSize } = data;
  return util.ajax({
    url: `/api/profile/segmentation/${projectId}/${segmentationId}/${baseTime}/${version}/${page}/${pageSize}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get"
  });
};
//  执行分群
api.runSegmentation = (projectId, data) => {
  let { segmentationId, baseTime } = data;
  return util.ajax({
    url: `/api/profile/segmentation/${projectId}/${segmentationId}/${baseTime}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put"
  });
};
// 下载分群用户列表表格
// api.exportSegmentationData = (projectId, data) => {
//   let { segmentationId, baseTime, version } = data;
//   return util.ajax({
//     url: `/api/profile/segmentation/export/${projectId}/${segmentationId}/${baseTime}/${version}`,
//     headers: {
//       userId: Cookies.get("userId"),
//       token: Cookies.get("token")
//     },
//     method: "get"
//   });
// };
// `${util.ajaxUrl}/api/profile/segmentation/export/${projectId}/${segmentationId}/${baseTime}/${version}`,
api.exportSegmentationData = (projectId, data) => {
  let { segmentationId, baseTime, version } = data;
  return fetch(

    `/api/profile/segmentation/export/${projectId}/${segmentationId}/${baseTime}/${version}`,
    {
      headers: { userId: Cookies.get("userId"), token: Cookies.get("token") }
    }
  );
};

// 删除分群
api.removeSegmentation = (projectId, segmentationId) => {
  return util.ajax({
    url: `/api/profile/segmentation/${projectId}/${segmentationId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};
// 上传用户列表
api.segmentationUploadFile = (projectId, segmentationId, data) => {
  return util.ajax({
    url: `/api/profile/segmentation/upload/${projectId}/${segmentationId}`,
    headers: { userId: Cookies.get("userId"), token: Cookies.get("token") },
    method: "put",
    data: data
  });
};
// 运营计划
//20.2 运营计划-查询分组
api.operationGroup = projectId => {
  return util.ajax({
    url: `/api/operation/group/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//20.4 创建计划
api.postOperation = (params, data) => {
  let { projectId, groupId } = params;
  return util.ajax({
    url: `/api/operation/plan/${projectId}/${groupId}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};
api.putOperation = (params, data) => {
  let { projectId, groupId, id } = params;
  return util.ajax({
    url: `/api/operation/plan/${projectId}/${groupId}/${id}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};
// -------------------------------
//查询运营计划整体状态
api.operationGroupStatus = params => {
  let { projectId, startTime, endTime } = params
  return util.ajax({
    url: `/api/operation/plan/overall/status/${projectId}`,
    method: "get",
    params: filterUndefined({
      ...params,
      projectId: undefined
    }),
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//查询计划列表
api.getplanlist = params => {
  let { projectId, page, pageSize, planName, planGroupId, status } = params;
  return util.ajax({
    url: `/api/operation/plan/panel/${projectId}/${page}/${1000}?${planGroupId ? "planGroupId=" + planGroupId : ""
      }${status ? "&statuses=" + status : ""}${planName ? "&planName=" + planName : ""
      }`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//查询短信配置
api.ChaXunMessage = projectId => {
  return util.ajax({
    url: `/api/message/conf/sms/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//创建短信配置
api.CreateMessage = (projectId, data) => {
  return util.ajax({
    url: `/api/message/conf/sms/${projectId}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//创建推送账号
api.CreatePush = (projectId, data) => {
  return util.ajax({
    url: `api/message/conf/push/${projectId}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//查询推送配置列表
api.PushList = projectId => {
  return util.ajax({
    url: `/api/message/conf/push/list/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//删除短信配置
api.deleteMesList = params => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/sms/${projectId}/${id}`,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//修改短信配置
api.editDuanXin = (params, data) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/sms/${projectId}/${id}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//启停短信配置
api.controlDuanxin = (params, single) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/sms/enabled/${projectId}/${id}?enabled=${single}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//修改推送账号
api.editPush = (params, data) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/push/${projectId}/${id}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//删除推送账号
api.deletePushList = params => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/push/${projectId}/${id}`,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//启停推送账号
api.controlPush = (params, single) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/push/enable/${projectId}/${id}?enabled=${single}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//创建Webhook
api.CreateWebhook = (projectId, data) => {
  return util.ajax({
    url: `/api/message/conf/webhook/${projectId}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//查询webhook配置列表
api.getWebList = projectId => {
  return util.ajax({
    url: `/api/message/conf/webhook/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//启停Webhook
api.controlWebhook = (params, single) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/webhook/status/${projectId}/${id}?enabled=${single}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//修改webhook
api.editWebhook = (params, data) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/webhook/${projectId}/${id}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//删除webHook
api.deleteWebList = params => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/webhook/${projectId}/${id}`,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//查询电子邮件配置
api.getEmailList = projectId => {
  return util.ajax({
    url: `/api/message/conf/email/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//创建电子邮件
api.CreateEmail = (projectId, data) => {
  return util.ajax({
    url: `/api/message/conf/email/${projectId}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//修改Email
api.editEmail = (params, data) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/email/${projectId}/${id}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//删除Email
api.deleteEmail = params => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/email/${projectId}/${id}`,
    method: "DELETE",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//启停电子邮件
api.controlEmail = (params, single) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/email/enabled/${projectId}/${id}?enabled=${single}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//测试发送消息
api.PushMessage = (params, data) => {
  let { kind, projectId, id } = params;
  return util.ajax({
    url: `/api/message/conf/${kind}/test/${projectId}/${id}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//查询用户触达限制规则
api.ChaLimit = projectId => {
  return util.ajax({
    url: `/api/operation/rule/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//增加用户触达限制
api.AddLimit = (projectId, data) => {
  return util.ajax({
    url: `/api/operation/rule/${projectId}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

//修改用户触达限制规则
api.editLimit = (params, data) => {
  let { projectId, id } = params;
  return util.ajax({
    url: `/api/operation/rule/${projectId}/${id}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data
  });
};

// 删除用户触达限制规则
api.deleLimit = parmas => {
  let { projectId, id } = parmas;
  return util.ajax({
    url: `/api/operation/rule/${projectId}/${id}`,
    method: "delete",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//开关用户触达限制
api.controlLimit = parmas => {
  let { projectId, kind, closed } = parmas;
  return util.ajax({
    url: `/api/operation/rule/switch/${projectId}/${kind}?closed=${closed}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//删除计划
api.deleOpera = parmas => {
  let { projectId, id } = parmas;
  return util.ajax({
    url: `/api/operation/plan/${projectId}/${id}`,
    method: "delete",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//查询计划列表

// /api/operation/plan/panel/{projectId}/{page}/{pageSize}?planName=xxxx&groupId=1234&status=paused,expired
// **查询条件，全部可选**
// - planType：计划类型
// - creator：创建人id
// - messageChannelAccountIds：触达通道的账号id列表，用英文逗号分隔
// - startTime：计划开始时间在startTime和endTime之间或者计划结束时间在startTime和endTime之间
// - endTime：见startTime
// - planName：计划名称（模糊匹配）
// - groupId：计划分组id，应首先访问查询计划分组接口
// - status:状态 （paused 已暂停，expired：true 已结束，running 运行中,auditing 审批中）
api.queryplanlist = param => {
  const {
    projectId,
    page,
    pageSize,
    planType,
    creator,
    messageChannelAccountIds,
    startTime,
    endTime,
    planName,
    status,
    messageChannelTypes
  } = param;
  //
  // ${endTime ? "&endTime=" + endTime : ""}
  const query = `${startTime ? "startTime=" + startTime : ""}${endTime ? "&endTime=" + endTime : ""}${planType ? "&planType=" + planType : ""
    }${creator ? "&creator=" + creator : ""}${messageChannelAccountIds
      ? "&messageChannelAccountIds=" + messageChannelAccountIds
      : ""
    }${planName ? "&planName=" + planName : ""
    }${status ? '&statuses=' + status : ""}${messageChannelTypes ? '&messageChannelTypes=' + messageChannelTypes : ""}
    `;
  console.log(messageChannelTypes,)
  return util.ajax({
    url: `/api/operation/plan/list/${projectId}/${page}/${pageSize}/?${query}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//查询创建人列表
api.ChaPerson = projectId => {
  return util.ajax({
    url: `/api/operation/plan/creators/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//按id查询计划
api.getOperaId = parmas => {
  let { projectId, id } = parmas;
  return util.ajax({
    url: `/api/operation/plan/${projectId}/${id}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//查询运营结果列表
api.getOperaResult = parmas => {
  let { projectId, id, page, pageSize, startTime, endTime, target = 0, groupType, groupName } = parmas;
  return util.ajax({
    url: `/api/operation/result/${projectId}/${id}/${groupName}/${page}/${pageSize}?target=${target}&startTime=${startTime}&endTime=${endTime}&groupType=${groupType}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};



//查询运营计划统计结果
api.getTotalResult = parmas => {
  let { projectId, id, startTime, endTime } = parmas;
  return util.ajax({
    url: `/api/operation/statistic/result/${projectId}/${id}?startTime=${startTime}&endTime=${endTime}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//修改计划组内顺序
api.ChangeListIndex = parmas => {
  let { projectId, groupId, ids } = parmas;
  return util.ajax({
    url: `/api/operation/plan/group/${projectId}/${groupId}/${ids}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

api.putPlanGroupById= parmas => {
  let { projectId, groupId, id } = parmas;
  return util.ajax({
    url: `/api/operation/plan/group/${projectId}/${id}?groupId=${groupId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//删除分组
api.DeleGroupName = params => {
  let { projectId, id } = params
  return util.ajax({
    url: `/api/operation/group/${projectId}/${id}`,
    method: "delete",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
}


//修改组名
api.EditGroupName = params => {
  let { projectId, id, name } = params
  return util.ajax({
    url: `/api/operation/group/${projectId}/${id}?name=${name}`,
    method: "delete",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
}


api.ChangeGroupIndex = parmas => {
  let { projectId, ids } = parmas;
  return util.ajax({
    url: `/api/operation/group/sort/${projectId}/${ids}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//修改组名
api.EditG = parmas => {
  let { projectId, id, name } = parmas;
  return util.ajax({
    url: `/api/operation/group/name/${projectId}/${id}?name=${name}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//修改计划状态
api.ChangeOpstatus = parmas => {
  let { projectId, id, status } = parmas;
  return util.ajax({
    url: `/api/operation/plan/status/${projectId}/${id}?status=${status}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//操作历史
api.getPlanHistory = parmas => {
  let { projectId, id } = parmas;
  return util.ajax({
    url: `/api/operation/plan/history/${projectId}/${id}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//支持的推送通道
api.getPushRoad = parmas => {
  let { projectId } = parmas;
  return util.ajax({
    url: `/api/message/conf/support/push/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//导出运营计划结果
api.PushResult = parmas => {
  let { projectId, id, startTime, endTime } = parmas;


  return fetch(

    `/api/operation/result/export/${projectId}/${id}?startTime=${startTime}&endTime=${endTime}`,
    {
      headers: { userId: Cookies.get("userId"), token: Cookies.get("token"), }
    }
  );
};


//创建流程画布
api.createFlow = parmas => {
  let { projectId, data, draft = true } = parmas;
  return util.ajax({
    url: `/api/operation/flow/${projectId}?draft=${draft}`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data,
  });
};

api.editFlow = parmas => {
  let { projectId, id, data, draft } = parmas;
  return util.ajax({
    url: `/api/operation/flow/${projectId}/${id}?draft=${draft}`,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: data,
  });
};

api.deleteFlow = parmas => {
  let { projectId, id } = parmas;
  return util.ajax({
    url: `/api/operation/flow/${projectId}/${id}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  });
};

api.changeFlow = parmas => {
  let { projectId, id, status } = parmas;
  return util.ajax({
    url: `/api/operation/flow/status/${projectId}/${id}?status=${status}`,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  });
};




function filterUndefined(obj) {
  return Object.keys(obj).filter(key => Boolean(obj[key])).reduce((result, key) => {
      result[key] = obj[key];
      return result;
  }, {});
}
//查询流程画布列表
api.getFlowList = parmas => {
  let { projectId, page, pageSize, flowType, creator, messageChannelAccountIds, messageChannelTypes, name, startTime, endTime, status } = parmas;
  return util.ajax({
    url: `/api/operation/flow/${projectId}/${page}/${pageSize}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    params: filterUndefined({
      startTime: startTime && dayjs(startTime).format('YYYY-MM-DD'),
      endTime: endTime && dayjs(endTime).format('YYYY-MM-DD'),
      flowType,
      creator,
      messageChannelAccountIds,
      messageChannelTypes,
      name,
      status
    })
  });
};

//查询流程画布整体运行状态
api.getFlowStatus = parmas => {
  let { projectId, startTime, endTime } = parmas;
  return util.ajax({
    url: `/api/operation/flow/overall/status/${projectId}?startTime=${startTime}&endTime=${endTime}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//查询流程创建人
api.getFlowCreater = parmas => {
  let { projectId } = parmas;
  return util.ajax({
    url: `/api/operation/flow/creators/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};


//查询运营计划创建人
api.getPlanCreater = parmas => {
  let { projectId } = parmas;
  return util.ajax({
    url: `/api/operation/plan/creators/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

// 执行查询
api.getExecute = (projectId, params) => {
  return util.ajax({
    url: `/api/sqlparser/sql/execute/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params,
  })
}
// 取消查询
api.canelReq = (param) => {
  return util.ajax({
    url: `/api/analysis?type=${param}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete",

  })
}

//添加历史
api.savaExecute = (projectId, params) => {
  return util.ajax({
    url: `/api/sqlparser/sql/history/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params
  });
};
// 查询历史
api.getHistory = (projectId) => {
  return util.ajax({
    url: `/api/sqlparser/sql/history/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
// 删除历史
api.delHistory = projectId => {
  return util.ajax({
    url: `/api/sqlparser/sql/history/${projectId}`,
    method: "delete",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
// 查询表目录
api.getTableList = projectId => {
  return util.ajax({
    url: `/api/sqlparser/table/list/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

// 查询目录列表   id?单:全
api.getFileList = (projectId, id) => {
  return util.ajax({
    url: id ? `/api/sqlparser/file/list/${projectId}/${id}` : `/api/sqlparser/file/list/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//删除保存的语句
api.delFIle = (projectId, id) => {
  return util.ajax({
    url: `/api/sqlparser/file/${projectId}/${id}`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
//修改文件
api.updateFIle = (projectId, params) => {
  return util.ajax({
    url: `/api/sqlparser/file/${projectId}`,
    method: "put",
    data: params,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};
// 保存查询语句
api.saveStatement = (projectId, params) => {
  return util.ajax({
    url: `/api/sqlparser/file/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params
  });
};
// 创建目录
api.createCatalogue = (projectId, params) => {
  return util.ajax({
    url: `/api/sqlparser/catalogue/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params
  });
};
// 查询保存的语句   单
api.getSaveStatement = (projectId, id) => {
  return util.ajax({
    url: `/api/sqlparser/file/${projectId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get",
  });
};
// 查询保存的语句   全
api.getSaveStatementAll = (projectId) => {
  return util.ajax({
    url: `/api/sqlparser/file/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get",
  });
};
api.downloadSelectRes = (projectId, params) => {
  return util.ajax({
    url: `/api/sqlparser/sql/result/export/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params,
    cancelToken: new CancelToken(function executor(c) {
      window.cancle = c
    })
  })
}


//查询分布分析
api.CheckDistribution = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/distribution/report/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data,
  });
};


//查询指定时间和区间的用户列表
api.CheckDistributionPersonList = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/distribution/user/report/${projectId}?page=${data.page}&pageSize=${data.pageSize}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data,
  });
};


//按指定时间和区间的用户列表建群
api.CheckDistributionPersonGroup = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/distribution/user/segmentation/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};


//导出分析结果
api.PushDistributionTable = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/distribution/export/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};

//漏斗分析
api.CheckFunnel = params => {
  let { projectId, id, data, cache } = params
  return util.ajax({
    url: `/api/funnel/report/${projectId}/${id}?cache=false`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data,
  });
};


//查询全部的漏斗
api.getFunnelList = parmas => {
  let { projectId } = parmas;
  return util.ajax({
    url: `/api/funnel/${projectId}`,
    method: "get",
    headers: {
      Accept: "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    }
  });
};

//创建漏斗
api.CreateFunnel = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/funnel/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};


//删除漏斗
api.deleteFunnel = param => {
  let { projectId, id } = param;
  return util.ajax({
    url: `/api/funnel/${projectId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "delete"
  });
};

//修改漏斗
api.CurrentFunnel = param => {
  let { projectId, id, data } = param;
  return util.ajax({
    url: `/api/funnel/${projectId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data,
  });
};

//导出漏斗分析
api.PushFunnelTable = params => {
  let { projectId, data, id } = params
  return util.ajax({
    url: `/api/funnel/export/${projectId}/${id} `,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};

//漏斗分析添加用户分群
api.AddFunnelPerson = params => {
  let { projectId, id, data } = params
  return util.ajax({
    url: `/api/funnel/segmentation/${projectId}/${id}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
}


//漏斗分析添加用户列表
api.AddFunnelList = params => {
  let { projectId, id, data } = params
  return util.ajax({
    url: `/api/funnel/users/report/${projectId}/${id}?cache=true&page=${data.page}&pageSize=${data.pageSize}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data,
  });
}

//请求间隔分析
api.RequestInterval = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/interval/report/${projectId}?cache=true`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data,
  });
}

//导出间隔分析
api.PushInterval = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/interval/export/${projectId}?cache=true`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};

// 1.查询留存
api.getRetentions = (projectId, param) => {
  return util.ajax({
    url: `/api/retentions/report/${projectId}?cache=${true}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: param
  }).then(res => {
    res.data.fields.list.splice(5000, res.data.fields.list.length - 1000)
    return res
  })
};

// 2.留存用户列表
api.getRetentionsUsers = (projectId, param, page) => {
  return util.ajax({
    url: `/api/retentions/users/report/${projectId}?cache=${true}&page=${page}&pageSize=15`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: param
  });
};
// 3.按照分析结果建群
api.getRetentionsSeg = (projectId, param) => {
  return util.ajax({
    url: `/api/retentions/segmentation/report/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: param
  });
};
// 4.留存导出
api.getRetentionsExport = (projectId, param) => {
  return util.ajax({
    url: `/api/retentions/export/${projectId}?cache=${true}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: param
  });
};

// 用户路径
//查询用户路径分析
api.CheckBeHaviorPath = (projectId, params) => {
  return new Promise(resolve => {
    util.ajax({
      url: `/api/user/behavior/paths/report/${projectId}?cache=true`,
      headers: {
        "Content-Type": "application/json",
        userId: Cookies.get("userId"),
        token: Cookies.get("token")
      },
      method: "post",
      data: params,

    }).then(res => {
      if (res.data.fields && res.data.fields.graph) {
        res.data.fields.graph.nodes.sort((a, b) => b.paths - a.paths)
      }
      resolve(res)
    })
  })
};

// 查询用户列表
// /api/user/behavior/users/report/{projectId}?cache=true&page=1&pageSize=1
api.haviorPathUserList = (projectId, params) => {
  return util.ajax({
    url: `/api/user/behavior/path/node/users/report/${projectId}?cache=true&page=${params.page}&pageSize=${params.pageSize}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params,

  });
};

api.userBehaviorPathEdgeUsers = (projectId, params) => {
  return util.ajax({
    url: `/api/user/behavior/path/edge/users/report/${ projectId }?cache=true&page=${ params.page }&pageSize=${ params.pageSize}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params,

  });
};

api.userBehaviorPathNodeSegmentation = (projectId, params) => {
  return util.ajax({
    url: `/api/user/behavior/path/node/segmentation/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params,
  });
};

api.userBehaviorPathEdgeSegmentation = (projectId, params) => {
  return util.ajax({
    url: `/api/user/behavior/path/edge/segmentation/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: params,
  });
};


//查询ltv分析
api.checkLtvAnlys = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/ltv/report/${projectId}?cache=false`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data,
  });
};

//导出ltv分析
api.taskLtvAnalysis = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/ltv/export/${projectId}?cache=true`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
};


//查看ltv用户列表
api.CheckLtvPersonList = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/ltv/users/report/${projectId}?cache=true&page=${data.page}&pageSize=${data.pageSize}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data,
  });
};

//按照ltv结果建群
api.addltvGroup = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/ltv/segmentation/report/${projectId}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data: data
  });
}

//请求归因分析
api.checkAttrAnalysis = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/attribution/report/${projectId}?cache=true`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data,
  });
};

//导出归因分析
api.getAttrAnalysisExport = params => {
  let { projectId, data } = params
  return util.ajax({
    url: `/api/attribution/export/${projectId}?cache=true`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data,
  });
};

api.CheckFlow = (param) => {
  let {projectId,id} = param
  return util.ajax({
    url: `/api/operation/flow/${projectId}/${id}`,
    data: param,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  })
}


api.getFlowResult = (param) => {
  let {projectId,id, target = 0, startTime, endTime} = param
  return util.ajax({
    url: `/api/operation/flow/result/${projectId}/${id}/${target}?startTime=${startTime}&endTime=${endTime}`,
    data: param,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  })
}


api.getFlowStatisticResult = (param) => {
  let {projectId,id, target, startTime, endTime, nodeId, page, pageSize } = param
  return util.ajax({
    url: `/api/operation/flow/list/result/${projectId}/${nodeId}/${target}/${page}/${pageSize}?startTime=${startTime}&endTime=${endTime}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  })
}


api.getFlowResultExport = (param) => {
  let {projectId,id, target, startTime, endTime, nodeId, page, pageSize } = param

  return fetch(

    `/api/operation/flow/result/export/${projectId}/${nodeId}/${target}?startTime=${startTime}&endTime=${endTime}`,
    {
      headers: { userId: Cookies.get("userId"), token: Cookies.get("token"), }
    }
  );

  // return util.ajax({
  //   url:
  //   headers: {
  //     "Content-Type": "application/json",
  //     userId: Cookies.get("userId"),
  //     token: Cookies.get("token")
  //   },
  // })
}


api.getFlowNodesResult = (param) => {
  let {projectId,id, target, startTime, endTime, nodeId } = param
  return util.ajax({
    url: `/api/operation/flow/nodes/result/${projectId}/${nodeId}/${target}?startTime=${startTime}&endTime=${endTime}`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  })
}




//查询数据质量元数据
api.getDataQualityMetadata = (params) => {
  let { projectId, startTime, endTime } = params
  return util.ajax({
    url: `/api/data/quality/metas/${projectId}?startTime=${startTime}&endTime=${endTime}`,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params
  });
};

// 查询总计
api.buriedPointQueryTotal = (params) => {
  let { projectId, startTime, endTime, source, appVersion, status,eventName } = params;
  return util.ajax({
    url: `/api/data/quality/overall/${projectId}?startTime=${startTime}&endTime=${endTime}&source=${source}&appVersion=${appVersion}&status=${status}&eventName=${eventName}`,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params,
  })
}
// 查询事件上报统计
api.buriedPointQuery = (params) => {
  let { projectId, startTime, endTime, source, appVersion, status, page, pageSize,eventName } = params;
  return util.ajax({
    url: `/api/data/quality/count/${projectId}?startTime=${startTime}&endTime=${endTime}&source=${source}&appVersion=${appVersion}&status=${status}&page=${page}&pageSize=${pageSize}&eventName=${eventName}`,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params,
  })
}
// 修改采样率
api.setSamplingRate = (params) => {
  let { projectId, metaId, sampling, acceptable } = params;
  return util.ajax({
    url: `/api/data/quality/meta/${projectId}/${metaId}`,
    method: 'put',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params
  })
}

// 查询错误明细汇总
api.buriedPointQueryErrorsTotal = (params) => {
  let { projectId } = params;
  return util.ajax({
    url: `/api/data/quality/errors/summation/${projectId}`,
    method: 'post',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params
  })
}

// 查询错误明细
api.buriedPointQueryErrors = (params) => {
  let { projectId } = params;
  return util.ajax({
    url: `/api/data/quality/errors/details/${projectId}`,
    method: 'post',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params
  })
}

// 导出全部错误数据
api.qualityErrorsExport = (params) => {
  let { projectId } = params;
  return util.ajax({
    url: `/api/data/quality/errors/export/${projectId}`,
    method: 'post',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: params
  })
}


// 查询客户端回调地址,用于二维码生成
api.getTargetUrl = (projectId) => {
  // let { topic, nonce } = params;
  return util.ajax({
    url: `/api/data/quality/debug/client/${projectId}`,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token"),
    },
    data: projectId
  })
}

// 调试模式二维码
api.getDebugQR = (params) => {
  let {projectId,targetUrl}=params
  return util.ajax({
    url: `/api/data/quality/debug/qrcode/${projectId}`,
    method: 'post',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data: targetUrl
  })
}

// 查询调试数据
api.getDebugData = (params) => {
  let { projectId } = params;
  return util.ajax({
    url: `/api/data/quality/debug/stream/${projectId}`,
    method: 'post',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token"),
    },
    data: params
  })
}

// 查询导入中数据
api.getImportingsData = (params) => {
  let { projectId } = params;
  return util.ajax({
    url: `/api/data/quality/importings/stream/${projectId}`,
    method: 'post',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token"),
    },
    data: params
  })
}

// 销毁debug和实时导入消费者
api.deleteConsumer = (params) => {
  console.log(params);
  let { projectId,topic, nonce } = params;
  return util.ajax({
    url: `/api/data/quality/consumer/destroy/${projectId}?topic=${topic}&nonce=${nonce}`,
    method: 'put',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token"),
    },
    data: params
  })
}


// 查询用户distinctId
api.getUserDistinctId = (params) => {
  let {projectId,nonce}=params
  return util.ajax({
    url: `/api/data/quality/debug/distinct/${projectId}/${nonce}`,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token"),
    },
    data: projectId
  })
}

api.getCoverRatio = (params) => {
  let {projectId, id}=params
  return util.ajax({
    url: `/api/operation/convertRatio/${projectId}/${id}`,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token"),
    },
  })
}



api.getOverallResult = (params) => {
  let {projectId, id, groupType, startTime, endTime, target = 0, groupName}=params
  return util.ajax({
    url: `/api/operation/group/result/${projectId}/${id}/${groupName}?startTime=${startTime}&endTime=${endTime}&target=${target}`,
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token"),
    },
  })
}


api.postUserTagDirList = (projectId, data) => {
  return util.ajax({
    url: `/api/user/tag/dir/list/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "POST",
    data
  })
}
api.putUserTagDocUpload = (projectId, data) => {
  return util.ajax({
    url: `/api/user/tag/doc/upload/${ projectId }`,
    headers: {
      "Content-Type": "multipart/form-data",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data
  })
}
api.putUserTag = (projectId, tagId, data) => {
  return util.ajax({
    url: `/api/user/tag/${ projectId }/${ tagId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "put",
    data
  })
}
api.putUserTagTrash = (projectId, tagIds) => {
  return util.ajax({
    url: `/api/user/tag/trash/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "PUT",
    data: {
      tagIds: tagIds
    }
  })
}
api.postUserTagTrashList = (projectId, data) => {
  return util.ajax({
    url: `/api/user/tag/trash/list/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "POST",
    data
  })
}
api.deleteUserTag = (projectId, tagIds) => {
  return util.ajax({
    url: `/api/user/tag/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "DELETE",
    data: {
      tagIds
    }
  })
}
api.putUserTagTrashRevert = (projectId, tagIds) => {
  return util.ajax({
    url: `/api/user/tag/trash/revert/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "PUT",
    data: {
      tagIds: tagIds
    }
  })
}
api.putUserTagRename = (projectId, id, cname) => {
  return util.ajax({
    url: `/api/user/tag/rename/${ projectId }/${ id }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "PUT",
    data: {
      cname
    }
  })
}

api.postUserTagDirShift = (projectId, parentId, tagIds) => {
  return util.ajax({
    url: `/api/user/tag/dir/shift/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "POST",
    data: {
      parentId,
      tagIds
    }
  })
}

api.postUserTagDir = (projectId, data) => {
  return util.ajax({
    url: `/api/user/tag/dir/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "post",
    data
  })
}


api.getUserTagDirListBrief = (projectId, vagueName) => {
  return util.ajax({
    url: `/api/user/tag/dir/list/brief/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: "get",
    params: {
      vagueName
    }
  })

}

api.getUserTagCreator = (projectId, data) => {
  return util.ajax({
    url: `/api/user/tag/creator/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  })
}

api.putUserTagStatus = (projectId, id, status) => {
  return util.ajax({
    url: `/api/user/tag/status/${ projectId }/${ id }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: 'PUT',
    data: {
      status
    }
  })
}


api.postUserTag = (projectId, data) => {
  return util.ajax({
    url: `/api/user/tag/${ projectId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    method: 'post',
    data,
  })
}
api.getUserTag = (projectId, tagId) => {
  return util.ajax({
    url: `/api/user/tag/${ projectId }/${ tagId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
  })
}

api.postUserTagDistribution = (projectId, tagId, data) => {
  return util.ajax({
    url: `/api/user/tag/distribution/${ projectId }/${ tagId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data,
    method: "POST"
  })
}
// {
//   "sort": "TAG_ASC", //api/user/tagAsc,tagDesc,numbersAsc,numbersDesc
//     "groupBy": {
//     "key": "default", // 默认是default,default 有可能是离散的，默认的数据从mysql表里查，其他的调用接口计算
//       },
//   "startTime": dayjs().subtract(10, 'd').valueOf(),
//     "endTime": dayjs().add(10, 'd').valueOf()

// }
api.postUserTagDistributionHistory = (projectId, tagId, data) => {
  return util.ajax({
    url: `/api/user/tag/distribution/history/${ projectId }/${ tagId }`,
    headers: {
      "Content-Type": "application/json",
      userId: Cookies.get("userId"),
      token: Cookies.get("token")
    },
    data,
    method: "POST"
  })
}

api.getResource2 = (projectId) => {
  // return util.ajax({
  //   url: `/api/user/tag/relation/${ projectId }/2089`,
  //   headers: {
  //     "Content-Type": "application/json",
  //     userId: Cookies.get("userId"),
  //     token: Cookies.get("token")
  //   },
  //   method: "GET",
  // })


  // return util.ajax({
  //   url: `/api/user/tag/distribution/history/${ projectId }/${ 2089 }`,
  //   headers: {
  //     "Content-Type": "application/json",
  //     userId: Cookies.get("userId"),
  //     token: Cookies.get("token")
  //   },
  //   data: {
  //     "sort": "TAG_ASC", //api/user/tagAsc,tagDesc,numbersAsc,numbersDesc
  //     "groupBy": {
  //       "key": "default", // 默认是default,default 有可能是离散的，默认的数据从mysql表里查，其他的调用接口计算
  //     },
  //     "startTime": dayjs().subtract(10, 'd').valueOf(),
  //     "endTime": dayjs().add(10, 'd').valueOf()

  //   },
  //   method: "POST"
  // })

  // return util.ajax({
  //   url: `/api/user/tag/distribution/${ projectId }/${ 29 }`,
  //   headers: {
  //     "Content-Type": "application/json",
  //     userId: Cookies.get("userId"),
  //     token: Cookies.get("token")
  //   },
  //   method: 'POST',
  //   data: {
  //     "sort": "TAG_ASC", //api/user/tagAsc,tagDesc,numbersAsc,numbersDesc
  //     "top": 5, // 5 ,10,15,.. 前n项,n+1...n+k 都归属distribute的level为其他
  //     "groupBy": {
  //       "key": "discrete",
  //            // number 类型discrete",default ,region
  //            // date 类型 nonSummary,nonSummaryUnit,summaryUnit

  //       "value": "sdf", //单个值
  //       //date 类型 value:DAY,  //HOUR,MINUTE,MONTH,WEEK,SEASON,YEAR

  //       "values": [12, 45, 67, 99] //区间表示
  //       // number类型区间 需要传升序排列数组
  //     }
  //   }
  // })



  // return util.ajax({
  //   url: `/api/user/tag/${ projectId }/${29}`,
  //   headers: {
  //     "Content-Type": "application/json",
  //     userId: Cookies.get("userId"),
  //     token: Cookies.get("token")
  //   },
  //   method: 'PUT',
  //   data: {
  //     tagId: 29,
  //     "tagName": "sfs22df",
  //     "cname": "sfs---f",
  //     "parentId": 17,
  //     "remark": "sdf",
  //     "updatePattern": 'ROUTINE', //手动    ROUTINE  例行更新
  //     "resultCount": -1, // -1 不限个数, 正整数n 是保留n个计算结果
  //     "tagPattern": "BASIC_INDICATOR",
  //     "tagDataType": "STRING",
  //     "dependTags": [], //依赖的标签，用于追溯标签血缘关系
  //     // 自定义类型
  //     rules: {
  //       "timeRange": {
  //         "specific": true,
  //         "startTime": 1753325997847,
  //         "endTime": 1753325997849,
  //         // "specific":fasel, lastDays:7
  //       },
  //       "eventName": "sfdsdf",
  //       "relation": "and",
  //       "filters": {
  //         "relation": "and",// or
  //         "conditions": [{
  //           "field": "fieldName",
  //           "function": "equal",
  //           "params": ["value1", "value2"]
  //         },]
  //       },
  //       "props": {
  //         "field": "filedName",
  //         "function": "sum"
  //       },
  //       "distribution": {
  //         "type": "discrete", // ,"percent","region"
  //         "layer": [{
  //           "name": "sdfs",
  //           "from": 0,
  //           "to": 10
  //         },]
  //       }
  //     }

  //   },
  // })

}

export default api;



// WEBPACK FOOTER //
// ./src/libs/api.js